module.exports = __webpack_public_path__ + "static/media/ic_tiktok.7819c0a4.svg";